import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FileItem } from '../../../models';

@Component({
  selector: 'app-file-action-bar',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './file-action-bar.component.html',
  styleUrl: './file-action-bar.component.scss',
})
export class FileActionBar {
  @Input() selectedFiles: FileItem[] = [];
}
